import { ReactComponent as DoubleRing } from "../../assets/images/loader/DoubleRing.svg";

const LoadingBar = ({ text = "" }) => {
    return (
        <div className="flex flex-col items-center gap-2">
            <span className="size-2 font-medium text-center">{text}</span>
            <DoubleRing className="fill-black dark:fill-itemPurple w-48 h-48" />
        </div>
    );
};

export default LoadingBar;
